(function () {
  'use strict';

  var instances = [];
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    return r.width > 0 && r.height > 0 &&
      r.bottom > -vh * 0.2 && r.top < vh * 1.2 &&
      r.right > 0 && r.left < vw;
  }

  function ensureShader(inst) {
    if (inst.shader) return inst.shader;
    if (!window.GradShader || !window.GradShader.create) return null;
    var shader = window.GradShader.create(inst.canvas);
    if (typeof window.GradShader.configFromElement === 'function') {
      shader.setConfig(window.GradShader.configFromElement(inst.canvas));
    }
    inst.shader = shader;
    return shader;
  }

  function syncInstance(inst) {
    var prerendering = !!document.prerendering;
    if (!inst.onScreen || (document.hidden && !prerendering)) {
      if (inst.shader && !prerendering) inst.shader.stop();
      return;
    }
    var shader = ensureShader(inst);
    if (!shader) return;
    shader.renderFrame();
    if (!prerendering && !prefersReducedMotion) shader.start();
  }

  function syncAll() {
    instances.forEach(syncInstance);
  }

  function onResize() {
    instances.forEach(function (inst) {
      if (!inst.shader) return;
      inst.shader.resize();
      if (prefersReducedMotion) inst.shader.renderFrame();
    });
  }

  function initCanvas(canvas) {
    if (!window.GradShader || !window.GradShader.create) return null;
    var hasIO = 'IntersectionObserver' in window;
    var inst = { canvas: canvas, shader: null, onScreen: !hasIO };

    if (hasIO) {
      new IntersectionObserver(function (entries) {
        inst.onScreen = entries[0].isIntersecting;
        syncInstance(inst);
      }, { rootMargin: '20%' }).observe(canvas);
      if (inViewport(canvas)) {
        inst.onScreen = true;
        syncInstance(inst);
      }
    } else {
      syncInstance(inst);
    }

    return inst;
  }

  var inited = false;

  function init() {
    var canvases = document.querySelectorAll('canvas[data-product]');
    if (!canvases.length || !window.GradShader) return;

    canvases.forEach(function (canvas) {
      if (canvas.dataset.peakShaderInit === '1') return;
      canvas.dataset.peakShaderInit = '1';
      var inst = initCanvas(canvas);
      if (inst) instances.push(inst);
    });

    if (inited) return;
    inited = true;
    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', syncAll);
    document.addEventListener('prerenderingchange', syncAll);
  }

  function paint() {
    if (!instances.length) init();
    instances.forEach(function (inst) {
      inst.onScreen = true;
      var shader = ensureShader(inst);
      if (shader) shader.renderFrame();
    });
  }

  window.PeakLoveProductShader = { init: init, paint: paint };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
